/**
 * Plugin registration helper
 * TODO: Implement per specs/phase-1-core-sdk/plan.md
 */

import type { PluginFunction } from './types';

export function use(this: any, pluginFn: PluginFunction): any {
  // Simple stub - just call the plugin function
  // TODO: Implement proper capability injection
  return pluginFn;
}
